<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description:
-->
<template>
  <div class="lc-steps">
    <div :class="['lc-steps__header']">
      <div
        v-for="(step, index) in steps"
        :key="'step_' + index"
        :class="['lc-step', value == index ? 'is-process' : '', index < value ? 'is-success' : '']"
        :style="stepStyle(index)"
      >
        <div class="lc-step__header">
          <div class="lc-step__headerBase">
            <div class="lc-step__header-style1">
              <div v-if="hasIndex" class="lc-step__icon">
                <span v-if="index < value" class="el-icon-check" />
                <span v-else>{{ index + 1 }}</span>
              </div>
              <div class="lc-step__title">{{ step.data.attrs.title }}</div>
            </div>
            <div v-if="index < steps.length - 1" class="lc-step__line" />
          </div>
          <slot :name="`desc${index + 1}`" />
        </div>
      </div>
    </div>
    <div class="lc-steps__contents">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LcSteps',
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    hasIndex: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number,
      default: 0
    },
  },
  watch: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    stepStyle(index) {
      const style = {};
      style.flexBasis = 100 / (this.steps.length - (this.isCenter ? 0 : 1)) + '%';
      if (index + 1 == this.steps.length) {
        style.maxWidth = 100 / this.steps.length + '%';
      }
      return style;
    }
  }
};
</script>
